export const DEFAULT_TITLE_COLOR = "neutral.90";
export const DEFAULT_SUBTITLE_COLOR = "neutral.80";
